import Common from '../../../../Common';

export interface FlowItem {
	id: id
	pbx_dad_flow_id: id
	pbx_modules_id: id
	value: string | null
	x: string
	y: string
	errors?: ErrorItem[]
}

interface Body {
	pbx_modules_id: id
	value?: id | null
	x?: string | number
	y?: string | number
}

interface UpdateBody {
	value?: id | null
	x?: string | number
	y?: string | number
}

interface ErrorItem {
	flowId: id
	destinationId: id
}

const Item = class extends Common {
	browse = (companyId: id, id: id): CustomResponse<FlowItem> =>
		this.get(`/company/${companyId}/pbxdad/flow/${id}/item`)

	create = (companyId: id, id: id, body: Body): CustomResponse<FlowItem> =>
		this.post(`/company/${companyId}/pbxdad/flow/${id}/item`, body)

	update = (companyId: id, id: id, itemId: id, body: UpdateBody, createSubFlow?: boolean, deleteSubFlow?: boolean, dryRun?: boolean): CustomResponse<FlowItem> =>
		this.patch(`/company/${companyId}/pbxdad/flow/${id}/item/${itemId}?createSubFlow=${createSubFlow ? 1 : 0}&deleteSubFlow=${deleteSubFlow ? 1 : 0}&dryRun=${dryRun ? 1 : 0}`, body)

	delete = (companyId: id, id: id, itemId: id, options?: { deleteSubFlow: boolean }) =>
		this.doDelete(`/company/${companyId}/pbxdad/flow/${id}/item/${itemId}${options?.deleteSubFlow ? '?deleteSubFlow=1' : ''}`)
}

export default Item
